import React from 'react';

interface IProps {
  lines: string[];
}

/**
 * Radbryter mellan varje element i en lista
 */
const EDTextLines: React.FC<React.PropsWithChildren<IProps>> = props => {
  return (
    <>
      {props.lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index !== props.lines.length - 1 && <br key={index} />}
        </React.Fragment>
      ))}
    </>
  );
};

export default EDTextLines;
